import React from "react";

const FreeEntryPromo: React.FC = () => {
  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h1>🎉 Gratulacje!</h1>
      <p>
        Otrzymujesz <strong>darmowe wejście</strong> do naszego klubu 🏋️‍♂️💦
      </p>
      <p>
        Pokaż ten ekran w recepcji, aby skorzystać z promocji. 🔑
      </p>
      <button
        style={{
          marginTop: "2rem",
          padding: "1rem 2rem",
          fontSize: "1rem",
          fontWeight: "bold",
          borderRadius: "8px",
          background: "linear-gradient(90deg,#1e90ff,#0077cc)",
          color: "#fff",
          border: "none",
          cursor: "pointer",
        }}
        onClick={() => window.location.href = "/"}
      >
        ⬅️ Wróć do aplikacji
      </button>
    </div>
  );
};

export default FreeEntryPromo;
